import { deck } from './cliente.js';

export const listar = (params = {}) => deck({ url: '/projects', params });
export const criar = (body) => deck({ method: 'post', url: '/projects', body });
export const ver = (key) => deck({ url: `/projects/${key}` });
export const salvar = (key, body) => deck({ method: 'put', url: `/projects/${key}`, body });
export const membrosDoProjeto = (key) => deck({ url: `/projects/${key}/members` });
export const acrescentarMembro = (key, body) => deck({ method: 'post', url: `/projects/${key}/members`, body });
export const atualizarMembro = (key, id, body) => deck({ method: 'put', url: `/projects/${key}/members/${id}`, body });
export const removerMembro = (key, id) => deck({ method: 'delete', url: `/projects/${key}/members/${id}` });

/* Fluxo de status */
export const status = (key) => deck({ url: `/projects/${key}/statuses` });
export const criarStatus = (key, body) => deck({ method: 'post', url: `/projects/${key}/statuses`, body });
export const salvarStatus = (key, id, body) => deck({ method: 'put', url: `/projects/${key}/statuses/${id}`, body });
export const apagarStatus = (key, id) => deck({ method: 'delete', url: `/projects/${key}/statuses/${id}` });
export const reordenarStatus = (key, status_ids) =>
    deck({ method: 'post', url: `/projects/${key}/statuses/reorder`, body: { status_ids } });

/* Tipos de issue */
export const tipos = (key) => deck({ url: `/projects/${key}/issue-types` });
export const criarTipo = (key, body) => deck({ method: 'post', url: `/projects/${key}/issue-types`, body });
export const salvarTipo = (key, id, body) => deck({ method: 'put', url: `/projects/${key}/issue-types/${id}`, body });
export const apagarTipo = (key, id) => deck({ method: 'delete', url: `/projects/${key}/issue-types/${id}` });
export const reordenarTipos = (key, type_ids) =>
    deck({ method: 'post', url: `/projects/${key}/issue-types/reorder`, body: { type_ids } });

/* Transicoes -- lista vazia significa "tudo permitido", e a resposta diz isso */
export const transicoes = (key) => deck({ url: `/projects/${key}/transitions` });
export const criarTransicao = (key, body) => deck({ method: 'post', url: `/projects/${key}/transitions`, body });
export const apagarTransicao = (key, id) => deck({ method: 'delete', url: `/projects/${key}/transitions/${id}` });

/* Vinculo opcional com o GitLab */
export const gitlab = (key) => deck({ url: `/projects/${key}/gitlab` });
export const salvarGitlab = (key, body) => deck({ method: 'put', url: `/projects/${key}/gitlab`, body });
export const removerGitlab = (key) => deck({ method: 'delete', url: `/projects/${key}/gitlab` });
